import React , {FocusEvent} from 'react';
import {useForm} from 'react-hook-form';
import b_ from 'b_';

import Block from 'client/common/components/block';
import {Textinput} from 'client/common/components/lego';
import SideBlock from 'client/common/components/side-block';
import BlockInput from 'client/common/components/block-input';

import {useUpdateSurveyName} from 'client/common/hooks/survey';

import I18N from 'assets/i18n/brandlift-project';

import {BordomatikBox, CreativeBox, SurveySlug} from 'client/common/types';

import './creative-settings-form.css';

const b = b_.with('creative-settings-form');

const i18n = I18N.creatives;

interface NameBlockProps {
    box: CreativeBox | BordomatikBox;
    slug: SurveySlug;
    disabled: boolean;
    register: ReturnType<typeof useForm>['register'];
    errors: ReturnType<typeof useForm>['errors'];
}

export default function NameBlock(props: NameBlockProps) {
    const {box, disabled, register, errors, slug} = props;

    const onNameUpdate = useUpdateSurveyName(slug);

    const handleNameUpdate = async (e: FocusEvent<HTMLInputElement>) => {
        await onNameUpdate(e.target.value);
    };

    return (
        <Block header={i18n.creativeSettings[`${box.name}Title`]}>
            <a
                className={b('more-info')}
                href={I18N.surveyStats.creativeStats.scoreboard.help.link[box.name]}
                target='_blank'
                rel='noopener noreferrer'
            >
                {i18n.creativeSettings.moreInfoText}
            </a>
            <BlockInput error={errors.creativeName}>
                <Textinput
                    size='m'
                    name='creativeName'
                    placeholder={i18n.creativeSettings.placeholders.creativeInput}
                    onBlur={handleNameUpdate}
                    disabled={disabled}
                    view='dl'
                    controlRef={register({
                        required: i18n.creativeSettings.validationMsg.creativeName
                    })}
                    state={errors.creativeName && 'error'}
                />
            </BlockInput>
            <SideBlock
                imageSet='example'
                text={i18n[`${box.name}Settings`].sideBlock.uploadText}
                link={i18n[`${box.name}Settings`].sideBlock.uploadLink}
            />
        </Block>
    );
}
